"use strict";

require("core-js/modules/es6.object.assign");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _flex = _interopRequireDefault(require("@waglabs/flex"));

var _icon = _interopRequireDefault(require("@waglabs/icon"));

var _image = _interopRequireDefault(require("@waglabs/image"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var Avatar = function Avatar(_ref) {
  var bg = _ref.bg,
      containerProps = _ref.containerProps,
      dataTestId = _ref.dataTestId,
      height = _ref.height,
      icon = _ref.icon,
      iconHeight = _ref.iconHeight,
      iconProps = _ref.iconProps,
      iconWidth = _ref.iconWidth,
      imageProps = _ref.imageProps,
      renderContent = _ref.renderContent,
      src = _ref.src,
      width = _ref.width;
  return _react.default.createElement(_flex.default, _extends({
    alignItems: "center",
    bg: bg,
    borderRadius: "50%",
    "data-testid": dataTestId,
    height: height,
    justifyContent: "center",
    m: "0",
    overflow: "hidden",
    p: "0",
    width: width
  }, containerProps), icon && !src && _react.default.createElement(_icon.default, _extends({
    backgroundPosition: "center",
    backgroundSize: "cover",
    height: iconHeight,
    name: icon,
    width: iconWidth
  }, iconProps)), src && _react.default.createElement(_image.default, _extends({
    backgroundPosition: "center",
    backgroundSize: "cover",
    height: height,
    src: src,
    width: width,
    borderRadius: "50%"
  }, imageProps)), renderContent && renderContent());
};

Avatar.defaultProps = {
  bg: 'wagGreen',
  height: '90px',
  iconHeight: '90px',
  iconWidth: '90px',
  width: '90px'
};
var _default = Avatar;
exports.default = _default;